var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"global-disclaimer",attrs:{"data-version":_vm.version}},[_c('span',{staticClass:"disclaimer-label"},[_vm._v("说明")]),_c('span',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }